<template>
    <div class="layout-inform-item dsp-flex" @click="clickItem">
        <div class="lo-inform-item-icon-box">
            <div class="lo-inform-item-icon" v-bind:class="'lo-inform-item-icon-' + source.iconType">
                <i class="iconfont" v-bind:class="'icon-' + source.iconType"></i>
                <span v-if="source.unread" class="lo-inform-item-unread"></span>
            </div>
        </div>
        <div class="lo-inform-item-content">
            <div class="lo-inform-item-date">{{source.timeText}}</div>
            <div class="lo-inform-item-title">{{source.titleText}}</div>
            <div class="lo-inform-item-detail">{{source.msg}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InformItem',
    props: {
        // type: good; manager; comment;
        source: {
            type: Object,
            default() { return {} }
        }
    },
    methods: {
        clickItem() {
            if(this.source.unread) {
                this.$store.dispatch('inform/setMsgRead', this.source)
            }
        }
    }
}
</script>